














import { Component, Prop, Vue } from 'vue-property-decorator';
import AgHeader from '../components/layout/header.vue';
import PrijavnicaForm from '../components/prijavnica/prijavnica-tm2021.vue';

@Component({ components: { AgHeader, PrijavnicaForm} })
export default class App extends Vue {
    @Prop()
    private msg!: string;
}
